import { render, staticRenderFns } from "./PersonalCard.vue?vue&type=template&id=664a37f8&scoped=true&"
import script from "./PersonalCard.vue?vue&type=script&lang=js&"
export * from "./PersonalCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCard.vue?vue&type=style&index=0&id=664a37f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664a37f8",
  null
  
)

export default component.exports